module.exports = __webpack_public_path__ + "static/media/tv-dark.71e0c83c.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/tv-dark.png
// module id = 1221
// module chunks = 0